import React from "react";
import { connect } from "react-redux";
import YourActivityItem from "./YourActivityItem";

const YourActivity = ({ customerData, appStateData, merchantData }) => {
  let { customer } = customerData;
  let { shopDomain } = appStateData;
  let { merchant } = merchantData;
  const isGermanLang = shopDomain === "nui-cosmetics.myshopify.com";

  return (
    <div className="youractivity-wrapper">
      <h2 className="youractivity-heading">
        {" "}
        {isGermanLang
          ? "Deine letzten Aktivitäten"
          : merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
          ? merchant?.customWidgetTheme?.textCustomization?.yourActivity ??
            "Your Activity"
          : "Your Activity"}
      </h2>
      <div className="youractivity-items-wrapper">
        {customer?.activity?.length > 0 ? (
          customer?.activity
            ?.map((item, index) => (
              <YourActivityItem
                key={index}
                title={item.name}
                desc={item.desc}
                date={item.date}
                divider={index !== 0}
              />
            ))
            ?.reverse()
        ) : (
          <p className="youractivity-no-items-text">
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.noActivity ??
                "No activity yet"
              : "No activity yet"}
          </p>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  merchantData: state.MerchantReducer,
  customerData: state.CustomerReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(YourActivity);
